import LoginCode from './LoginCode';
export default LoginCode;
